import { render, staticRenderFns } from "./EditPageAttrValueMain.vue?vue&type=template&id=5449e033"
import script from "./EditPageAttrValueMain.vue?vue&type=script&lang=js"
export * from "./EditPageAttrValueMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports